import { render, staticRenderFns } from "./ExternalLinks.vue?vue&type=template&id=72a95c01"
import script from "./ExternalLinks.vue?vue&type=script&lang=js"
export * from "./ExternalLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports